import React from 'react';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import AssessmentIcon from '@mui/icons-material/Assessment';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export default function RecentBidResults({ results, title = "Recent Bid Results" }) {
    const navigate = useNavigate();

    if (!results || results.length === 0) {
        return (
            <div className="dashboard_section">
                <div className="section_header">
                    <h3><AssessmentIcon /> {title}</h3>
                </div>
                <div className="empty_state small">
                    <p>No recent bid results to show.</p>
                </div>
            </div>
        );
    }

    return (
        <div className="dashboard_section">
            <div className="section_header">
                <h3><AssessmentIcon /> {title}</h3>
            </div>
            <div className="bid_results_list">
                {results.map((result) => (
                    <div 
                        key={result.id} 
                        className={`bid_result_item ${result.status}`}
                        onClick={() => navigate(`/project-details/${result.project_id}/true`)}
                    >
                        <div className="result_icon">
                            {result.status === 'hired' ? (
                                <CheckCircleIcon className="won_icon" />
                            ) : (
                                <CancelIcon className="lost_icon" />
                            )}
                        </div>
                        <div className="result_content">
                            <h4 className="result_project">
                                {result.project?.project_name?.length > 35 
                                    ? `${result.project.project_name.slice(0, 35)}...` 
                                    : result.project?.project_name}
                            </h4>
                            <div className="result_details">
                                <span className={`result_status ${result.status}`}>
                                    {result.status === 'hired' ? 'Won' : 'Not Selected'}
                                </span>
                                <span className="result_date">
                                    {moment(result.awarded_date || result.updated_at).fromNow()}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
}
